export default function () {
  const widgetName = 'offsetCards';
  const widgetOpts = offsetCardsOpts;

  // you can remove this and impor the validateWindowSize auxiliary function under Helpers/helpers.js
  const breakpoint = 800;
  const isDesktopScreen = $(window).width() >= breakpoint;
  const wrapContainerClass = 'offsetCards-container-wrapper';
  const $widget = $(`#${widgetName}`);
  const animateOnScroll = true;

  $widget.wrap(`<div class="${wrapContainerClass}"><div class="inner-container"></div></div>`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: ['all'],
    showDescription: false,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    textOverImage: true,
    moreButton: true,
    maxItemsVisible: 4,
    itemsPerPanel: 1,
    buyNowButton: false,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomCards(data.items);
        if (animateOnScroll && isDesktopScreen) {
          animationCards();
        }
      } else {
        $(`.${wrapContainerClass}`).remove();
      }
    },
  });

  function createCustomCards(widgetData) {
    $widget.find('.card-widget-item').each(function (x) {
      const { Title, URL } = widgetData[x];

      const $cardItem = $(this);
      $cardItem.find('.card-content').remove();
      $cardItem.append(`
          <div class="card-content">
            <div class="widget-title-wrapper">
              <span class="widget-title">
                ${Title}
              </span>
            </div>
          </div>`);

      if (URL) {
        $cardItem.attr('target', '_blank');
      } else {
        $cardItem.addClass('empty-card').removeAttr('href');
      }
    });
  }

  function animationCards() {
    window.addEventListener('scroll', function () {
      let windowPosition =
        (window.pageYOffset * 100) / (document.body.scrollHeight - window.innerHeight);
      if (windowPosition > 10) {
        $widget.addClass('offset-container');
      } else {
        $widget.removeClass('offset-container');
      }
    });
  }
}
